/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(11);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _contact = __webpack_require__(12);

var _contact2 = _interopRequireDefault(_contact);

var _rebox = __webpack_require__(13);

var _rebox2 = _interopRequireDefault(_rebox);

var _scroll = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {
  $(".read").click(function () {
    $(this).prev().toggle();
    if ($(this).text() == 'Weiterlesen …') {
      $(this).text('Weniger lesen');
    } else {
      $(this).text('Weiterlesen …');
    }
  });
});

(function () {
  'use strict';

  window.onscroll = function () {
    stickyNav();
  };

  var navbar = document.getElementById("navbar");

  var sticky = navbar.offsetTop;

  function stickyNav() {
    if (window.pageYOffset >= sticky) {
      navbar.classList.add("sticky");
    } else {
      navbar.classList.remove("sticky");
    }
  }

  function rebox() {
    $('.lightbox-thumbs').rebox({ selector: 'figure a' });
  }

  function initialize() {
    (0, _contact2.default)('#contact-form');
    rebox();
    (0, _scroll.toggleBelowFold)();
    (0, _scroll.scrollSpy)('.header-nav-sub:visible', { offset: 0 });
    (0, _scroll.smoothScroll)('a[href^="#"]', { offset: 0 });
  }

  initialize();
})();

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (id, options) {
  return new ContactForm(id, options);
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactForm = exports.ContactForm = function () {
  function ContactForm(id, options) {
    _classCallCheck(this, ContactForm);

    this.$el = $(id);
    if (this.$el.length < 1) {
      return;
    }

    options = this.options = $.extend({ focus: true, hidden: [] }, options);

    var prefix = 'contact';
    this.$el.on('submit', this.onSubmit.bind(this));
    this.$content = this.$el.find('.' + prefix + '-content');
    this.$confirmation = this.$el.find('.' + prefix + '-confirmation');
    this.$error = this.$el.find('.' + prefix + '-error');
    if (options.focus) {
      this.$el.find('input').eq(0).focus();
    }
  }

  _createClass(ContactForm, [{
    key: 'onSubmit',
    value: function onSubmit(evt) {
      function blur() {
        $(evt.target).find('[type="submit"]').blur();
      }

      var fields = $.merge(this.options.hidden, this.$el.serializeArray());

      $.post(this.$el.attr('action'), $.param(fields)).then(function (data) {
        var ticket = data ? '(Ticket #' + data + ')' : '';
        blur();
        this.$error.hide();
        this.$el.find(':input').prop('disabled', true);
        this.$content.find('[type=submit]').css('visibility', 'hidden');
        this.$content.css('opacity', '.5');
        this.$confirmation.show();
        this.$confirmation.find('.ticket').text(ticket).css('opacity', '.7');
      }.bind(this), function (res) {
        blur();
        this.$error.show();
        this.$error.find('.status').text(res.status);
        this.$error.find('.error').text(res.responseText);
      }.bind(this));

      return false;
    }
  }]);

  return ContactForm;
}();

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rebox;
function rebox(element) {
  $(element).rebox({ selector: 'figure a' });
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleBelowFold = toggleBelowFold;
exports.scrollSpy = scrollSpy;
exports.fixScrollPosition = fixScrollPosition;
exports.smoothScroll = smoothScroll;
function toggleBelowFold() {
  var onScroll = function onScroll() {
    $('body').toggleClass('scroll', $(window).scrollTop() > 100);
  };

  $(window).on('scroll', onScroll);
  onScroll();
}

function scrollSpy(selector, options) {
  options = $.extend({
    target: selector
  }, options);
  var $spy = $('body').scrollspy(options);
  $spy.data('bs.scrollspy').selector = selector + ' > li > a';
  $spy.scrollspy('refresh');
  $spy.scrollspy('process');
  fixScrollPosition(options);
}

function fixScrollPosition(options) {
  if (window.location.hash) {
    setTimeout(function () {
      if (!/^#\w+/.test(window.location.hash)) return;
      $('html, body').scrollTop($(window.location.hash).offset().top - options.offset);
    });
  }
}

function smoothScroll(element, options) {
  $(element).smoothScroll(options);
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// Scripts/application.js